import { render, staticRenderFns } from "./JamList.vue?vue&type=template&id=a0f54ac0&scoped=true"
import script from "./JamList.vue?vue&type=script&lang=js"
export * from "./JamList.vue?vue&type=script&lang=js"
import style0 from "./JamList.vue?vue&type=style&index=0&id=a0f54ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f54ac0",
  null
  
)

export default component.exports